import React from "react";
import profile from "../../assets/about_me.png";
import styles from "./Profile.module.css";

const Profile = () => {
  return (
    <section className={styles.Profile}>
      <div className={styles.Image}>
        <img src={profile} alt="_avatar_" />
      </div>
    </section>
  );
};

export default Profile;
